import React, { useEffect, useRef } from 'react';

import {
  ComeAffittareCasa,
  CoseProtezioneZappyrent,
  FAQ,
  LaMiglioreAssicurazione,
  PercheAffittareCasa,
  ZappyrentTutelaInquilino,
} from '.';
import {
  StyledSection,
  StyledSubContainer,
} from '../TextPageLandlord/TextPageLandlord.styles';
import { IProtezioneZappyrentProps } from './ProtezioneZappyrent.types';

const ProtezioneZappyrent = ({
  updateContext,
}: IProtezioneZappyrentProps): JSX.Element => {
  const refs = useRef<HTMLElement[]>([]);
  const addToRefs = (refs, element) => {
    if (element && !refs.current.includes(element)) {
      refs.current.push(element);
    }
  };

  useEffect(() => {
    updateContext && updateContext(refs);
  }, [refs, updateContext]);

  return (
    <StyledSubContainer>
      <StyledSection
        id="cose-protezione-zappyrent"
        ref={element => addToRefs(refs, element)}
      >
        <CoseProtezioneZappyrent />
      </StyledSection>
      <StyledSection
        id="la-migliore-garanzia"
        ref={element => addToRefs(refs, element)}
      >
        <LaMiglioreAssicurazione />
      </StyledSection>
      <StyledSection
        id="come-affittare-casa"
        ref={element => addToRefs(refs, element)}
      >
        <ComeAffittareCasa />
      </StyledSection>
      <StyledSection
        id="perche-affittare-casa"
        ref={element => addToRefs(refs, element)}
      >
        <PercheAffittareCasa />
      </StyledSection>
      <StyledSection
        id="zappyrent-tutela-inquilino"
        ref={element => addToRefs(refs, element)}
      >
        <ZappyrentTutelaInquilino />
      </StyledSection>
      <StyledSection id="faq" ref={element => addToRefs(refs, element)}>
        <FAQ />
      </StyledSection>
    </StyledSubContainer>
  );
};

export default ProtezioneZappyrent;
